export default __webpack_public_path__ + "static/media/portal_5.72cff621.png";